export interface IWarehouseAdminSupplierInvoiceData {
    id: number;
    supplier_id: number;
    date: string|null;
    memo_date: string|null;
    number: string|null;
    description: string|null;
    amount: number;
    vat_amount: number;
    currency: string|null;
    remark: string|null;
    created_at: string|null;
}

export default class WarehouseAdminSupplierInvoiceData {
    id: number;
    supplier_id: number;
    date: string|null;
    memo_date: string|null;
    number: string|null;
    description: string|null;
    amount: number;
    vat_amount: number;
    currency: string|null;
    remark: string|null;
    created_at: string|null;

    constructor(data: IWarehouseAdminSupplierInvoiceData) {
        this.id = Number(data.id);
        this.supplier_id = Number(data.supplier_id);
        this.date = data.date ?? null;
        this.memo_date = data.memo_date ?? null;
        this.number = data.number ?? null;
        this.description = data.description ?? null;
        this.amount = Number(data.amount ?? 0);
        this.vat_amount = Number(data.vat_amount ?? 0);
        this.currency = data.currency ?? null;
        this.remark = data.remark ?? null;
        this.created_at = data.created_at ?? null;
    }
}